<template>
  <mastery-modal
    button-variant="blue"
    name="payment-error"
    header-image="payment-error.svg"
    :header-image-size="'small'"
    primary-action-text="Update"
    type="masteryModalWhite"
    @primary-action-clicked="showUpdatePaymentModal"
    @close-fn="recordPastDueModalSeen"
  >
    An error occurred with your recent payment. To continue accessing premium content, please update your payment method.
  </mastery-modal>
</template>

<script>
import MasteryModal from '@/components/ui/masteryModal';

export default {
  name: 'PaymentErrorModal',
  components: { MasteryModal },
  methods: {
    recordPastDueModalSeen() {
      sessionStorage.setItem('pastDueModalSeen', true);
    },
    showUpdatePaymentModal() {
      this.$store.commit('ui/setProfileModalShown', 'updatePaymentInfoModal');
    },
  },
};
</script>
